import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class Widget extends Base {
	constructor(props) {
		super(props);
		this.state = {
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			caller: props.Caller,
			data: null,
			loading: true,
		};
	}
	componentDidMount() {
		this.httpPost("api/v1/common/getwidget", {
			id: this.getCurrentFormId(),
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e) {
        if (!this.isNull(e)) e.preventDefault();
		this.httpPost("api/v1/common/savewidget", {
			id: this.state.id,
			title: this.state.data.record.title,
			widgetType: this.state.data.record.widgetType,
			options: this.state.data.record.options,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	changeType(e) {
		this.state.data.record.widgetType = parseInt(e.target.value);
		this.state.data.record.options = "";
		this.setState({ data: this.state.data });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
			<div className="modal-dialog ui-draggable">
				<div className="modal-content">
					<div className="modal-body" style={{ "padding": "0" }}>
						<div className="modal-header modal-header-info">
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">ابزار</h4>
						</div>

						<div className="modal-body">
							<div className="container-fluid">
								<div className="dx-popup-content" style={{ "height": "auto" }} >
									<div>
										<div className="row">
											<div className="col-sm-4">
												<div className="form-group">
													<label for="name" className="title1">ابزار انتخابی</label>
													<select className="form-control input-sm" defaultValue={this.state.data.record.widgetType} onChange={e => this.changeType(e)} >
														<option value="1">دسترسی سریع</option>
														<option value="2">گزارشات</option>
														<option value="3">برترین محصولات فروش رفته</option>
														<option value="4">بانکها و صندوق ها</option>
														<option value="5">چکهای دریافتنی</option>
														<option value="6">چکهای پرداختنی</option>
														<option value="7">اسناد باز</option>
													</select>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-12">
												<div className="form-group">
													<label for="name" className="title1">عنوان</label><span className="red">*</span>
													<input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
												</div>
											</div>
										</div>
										{this.state.data.record.widgetType === 7 && <div className="row">
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[documents]')} onChange={e=>this.setOption('[]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													اسناد حسابداری
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[factors]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													فاکتورها
												</div>
											</div>
										</div>}
										{this.state.data.record.widgetType === 1 && <div className="row">
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[add_placeholder]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													سهامداران
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[coding]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													جدول حسابها
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[detail_account]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													حسابهای تفصیلی
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[new_document]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													ثبت سند حسابداری
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[invoice_sale]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													ثبت فاکتور فروش
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[]')} onChange={e => this.setOption('[recievment]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													دریافت وجه
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[payment]')} onChange={e => this.setOption('[payment]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													پرداخت وجه
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[cheque_in]')} onChange={e => this.setOption('[cheque_in]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													چکهای دریافتی
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[cheque_out]')} onChange={e => this.setOption('[cheque_out]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													چکهای پرداختی
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[add_remittance3]')} onChange={e => this.setOption('[add_remittance3]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													ثبت رسید انبار
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="switch">
														<input autocomplete="off" className="widget_actions" defaultChecked={this.state.data.record.options.includes('[add_remittance4]')} onChange={e => this.setOption('[add_remittance4]', e.target.checked)} type="checkbox" />
														<span className="slider round"></span>
													</label>
													ثبت حواله انبار
												</div>
											</div>
										</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-default btn-smoke" onClick={e=>this.closeMe() }>انصراف</button>
							<button type="submit" onClick={e => this.save(e)} className="btn btn-success">ذخیره</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm()
			];

		return contents;
	}
}